export default "__VITE_ASSET__BAaywuwI__"